
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Component, Prop, Vue } from "vue-property-decorator";
import Auth from "@/lib/common/auth";
import vuexStore from "@/store/vuex-store";
import {
  NRAttachment,
  NRCandidate,
  NRProject,
  NRProjectCase,
  NRProjectShortVideoCase
} from "@/lib/model/NRXQ/candidate";
import NRProjectCaseEdit from "./nr-project-case-edit.vue";
import request from "@/lib/request/request";
import { NRClientType } from "@/lib/model/NRXQ/nr";
import gateway from "@/lib/request/gateway";
//上传中的文件
class UploadingFile {
  fileName = "";
  fileStatus = "";
  fileType = "";
}

@Component({
  components: {}
})
export default class NRAttachmentEdit extends Vue {
  @Prop({
    type: NRCandidate,
    default: () => {
      return new NRCandidate();
    }
  })
  cv!: NRCandidate;
  @Prop() atsCvId!: any;
  @Prop({ default: false, type: Boolean }) isResultPage!: boolean; //是否是报告页展示
  @Prop({ type: String, default: NRClientType.NRClientTypeAdmin })
  clientType!: string;

  uploading = false;
  showDel = false;
  currentDeleteFile!: NRAttachment;
  upIndex = 0; //正在上传的是哪个框
  percent0 = 0;
  percent1 = 0;
  percent2 = 0;
  percent3 = 0;
  percent4 = 0;
  bar0 = false;
  bar1 = false;
  bar2 = false;
  bar3 = false;
  bar4 = false;
  showBigImg = false;
  bigImgUrl = "";
  isVideo = false;
  uploadingFileList: UploadingFile[] = []; //上传中的文件;

  sectionList = [
    "案例数据截图",
    "策划类文件",
    "复盘文件",
    "管理执行文件",
    "学习文件"
  ];
  currentUploadSection = "";
  setBar(i: number) {
    this["bar" + i] = true;
  }
  showBar(i: number) {
    return this["bar" + i];
  }
  showPer(i: number) {
    return this["percent" + i];
  }

  created() {
    //
  }

  mounted() {
    //
  }

  uploadFile(data: { filename: string; file: File }) {
    console.log(data);
    console.log(this.currentUploadSection);
    const { filename, file } = data;
    //存下当前哪个框
    const indexNow = this.upIndex;
    const upLoadType = this.currentUploadSection;
    this["percent" + indexNow] = 0; //进度条
    const f = new UploadingFile();
    f.fileName = file.name;
    f.fileStatus = "上传中";
    f.fileType = upLoadType;
    this.uploadingFileList.push(f);

    //获取上传凭证
    gateway.anonymousGetPostPolicy(file.name).then((postRes: any) => {
      if (postRes) {
        // 上传到oss
        const config: any = {
          onUploadProgress: (progressEvent: any) => {
            //progressEvent.loaded:已上传文件大小
            //progressEvent.total:被上传文件的总大小
            this["percent" + indexNow] = this.computePer(
              progressEvent.loaded,
              progressEvent.total
            );
          }
        };
        this["bar" + indexNow] = true;

        gateway
          .upload(postRes, file, config)
          .then((res: any) => {
            this.onUploadSuccess(res, upLoadType);
          })
          .catch(() => {
            this.$message.warning("文件【" + file.name + "】上传失败，请重试");
            const i = this.uploadingFileList.findIndex(d => {
              return d.fileName === file.name;
            });
            this.uploadingFileList.splice(i, 1);
          })
          .finally(() => {
            this.uploading = false;
            this["bar" + indexNow] = false;
            // this.imageUrl = tempUrl;
            // this.$emit("change", this.imageUrl);
          });
      }
    });
  }

  async onUploadSuccess(file: any, upLoadTypeNow?: string) {
    let url = "";
    const attachment = new NRAttachment();
    attachment.fileName = file.filename;
    attachment.fileType = upLoadTypeNow || this.currentUploadSection;
    attachment.fileUrl = file.object;
    const param = {
      nrAttachment: attachment
    };
    if (this.clientType == NRClientType.NRClientTypeCandidate) {
      url = "/aiExam/atsPublic/cvSaveNrAttachment";
      param["atsCvOutId"] = this.atsCvId;
    } else if (this.clientType == NRClientType.NRClientTypeAdmin) {
      url = "/aiExam/atsAdmin/cvSaveNrAttachment";
      param["atsCvId"] = this.atsCvId;
    }
    const i = this.uploadingFileList.findIndex(d => {
      return d.fileName === file.filename;
    });
    this.uploadingFileList.splice(i, 1);
    try {
      const resp = await request.post(url, param);
      if (resp.data.code === 0) {
        const array = [];
        for (const item of resp.data.data.nrAttachmentList) {
          array.push(new NRAttachment().assign(item));
        }
        this.cv.nrAttachmentList = array;
        return true;
      }
    } catch (e) {
      console.log(e);
    }
    this.uploading = false;
    return false;
  }

  showDeleteFile(file: NRAttachment) {
    this.currentDeleteFile = file;
    this.showDel = true;
  }
  async deleteFile(file: NRAttachment) {
    this.showDel = false;
    let url = "";
    const param = {
      deleteFileId: file.fileId
    };

    if (this.clientType == NRClientType.NRClientTypeCandidate) {
      url = "/aiExam/atsPublic/cvSaveNrAttachment";
      param["atsCvOutId"] = this.atsCvId;
    } else if (this.clientType == NRClientType.NRClientTypeAdmin) {
      url = "/aiExam/atsAdmin/cvSaveNrAttachment";
      param["atsCvId"] = this.atsCvId;
    }
    try {
      const resp = await request.post(url, param);
      if (resp.data.code === 0) {
        const array = [];
        for (const item of resp.data.data.nrAttachmentList) {
          array.push(new NRAttachment().assign(item));
        }
        this.cv.nrAttachmentList = array;
        return true;
      }
    } catch (e) {
      console.log(e);
    }
    this.uploading = false;
    return false;
  }

  openLink(link: string) {
    window.open(link);
  }

  onProgress(event: any, file: any, fileList: any) {
    console.log(event);
  }

  attachmentList(type: string) {
    return this.cv.nrAttachmentList.filter((item: any) => {
      return item.fileType === type;
    });
  }
  //区分文件类型
  checkFileType(name: string) {
    if (
      ["PNG", "JPG", "png", "jpg", "bmp", "BMP"].includes(name.slice(-3)) ||
      ["JPEG", "jpeg"].includes(name.slice(-4))
    ) {
      return "img";
    } else if (
      ["rm", "RM"].includes(name.slice(-2)) ||
      [
        "mp4",
        "MP4",
        "avi",
        "AVI",
        "mov",
        "MOV",
        "flv",
        "FLV",
        "3gp",
        "3GP"
      ].includes(name.slice(-3)) ||
      ["rmvb", "RMVB"].includes(name.slice(-4))
    ) {
      return "video";
    } else {
      return "other";
    }
  }
  //打开文件
  openFile(type: string, url: string) {
    if (type === "img") {
      this.openImg(url);
    }
    if (type === "video") {
      this.openImg(url, "video");
    }
    if (type === "other") {
      this.openLink(url);
    }
  }
  //查看大图
  openImg(url: string, type = "") {
    this.isVideo = type === "video" ? true : false;
    this.bigImgUrl = url || "";
    this.showBigImg = true;
  }

  get showSaveButton() {
    return this.clientType == NRClientType.NRClientTypeCandidate;
  }
  computePer(i: number, ii: number) {
    const p = Number((Number(i) / Number(ii)).toFixed(3)) * 100;
    const t = String(p).split(".")[0];
    return Number(t);
  }
  //上传文件类型分类
  getUploadingFileList(type: string) {
    return this.uploadingFileList.filter((item: any) => {
      return item.fileType === type;
    });
  }
}
